/** User-approved colors from the Theme Settings explicit-save mock. */
export const saveFeedbackColors = {
  dirtyBackground: '#FDF8DC',
  dirtyBorder: '#ECE3AB',
  dirtyForeground: '#7A6412',
  actionBackground: '#0F1730',
  actionHoverBackground: '#1C2542',
  actionForeground: '#FFFFFF',
  disabledBackground: '#D5D6DB',
  disabledForeground: '#8B8C96',
  savedForeground: '#1F6B3B',
} as const;
